module.exports = __webpack_public_path__ + "static/media/Bulk_vin_deliver_update_file.87c42ff0.csv";